import { AxiosError, AxiosInstance } from 'axios';
import { ErrorHandler, AuthErrorHandler } from '@/types';

export default class AxiosErrorHandler {
  axios: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  onError(handler: ErrorHandler) {
    this.axios.interceptors.response.use(undefined, (error: AxiosError) => {
      const { response } = error;
      if (!response || response.config.method === 'get' || response.status === 401) {
        return Promise.reject(error);
      }
      const { data } = response;
      handler({
        code: data.code,
        message: data.message,
      });
      return Promise.reject(error);
    });
  }

  onAuthError(handler: AuthErrorHandler) {
    this.axios.interceptors.response.use(undefined, (error) => {
      if (error.response.status !== 401) {
        return Promise.reject(error);
      }
      return handler()
        .then(() => { // eslint-disable-line
          return this.axios.request(error.config); // Retry the request after reauthenticating
        })
        .catch(() => { // eslint-disable-line
          return Promise.reject(error);
        });
    });
  }
}
